import gsap, { Power3 } from 'gsap';

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
// import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { ScrollItem__Default } from './ScrollItem__Default';

class ScrollItem__Bio extends ScrollItem__Default {
  images = [];
  parents = [];

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this.images = GetBy.class('__img', __link);
    for (let i = 0; i < this.images.length; i++) {
      const item = this.images[i];
      const pos = {
        x: Maths.maxminRandom(35, -35),
        y: Maths.maxminRandom(25, -25)
      }
      const rot = Maths.maxminRandom(20, -20);
      item.style.transformOrigin = 'center center';
      item.style.transform = `rotate(${rot}deg) translate3D(${pos.x}%, ${pos.y}%, 0)`;

      // const parent = item.parentNode;
      // parent.style.transformOrigin = 'center center';
      // parent.style.transform = 'scale3D(3, 3, 1)';
      // parent.style.opacity = 0;
      // this.parents.push(parent);
    }
  }

  // showAnimation() {
  // super.showAnimation();

  // for (let i = 0; i < this.parents.length; i++) {
  //   const parent = this.parents[i];
  //   const delay = i * .02;
  //   gsap.to(parent, { scaleX: 1.4, scaleY: 1.4, duration: .4, delay, ease: Power3.easeIn });
  //   gsap.to(parent, { opacity: 1, duration: .2, delay: delay + .2, ease: Power3.easeOut });
  //   gsap.set(parent, { scaleX: 1, scaleY: 1, delay: delay + .4 });
  // }
  // }
}

Scroll._registerClass('Bio', ScrollItem__Bio);